import * as React from 'react';
import { Label, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as style from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FlatTooltip = function FlatTooltip(_ref) {
  var flatId = _ref.flatId,
    price = _ref.price,
    hasDecoration = _ref.hasDecoration,
    flatInfo = _ref.flatInfo,
    onFlatOpen = _ref.onFlatOpen,
    similarOffersCount = _ref.similarOffersCount;
  var onClick = React.useCallback(function () {
    onFlatOpen(flatId);
  }, [flatId]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: style['label'],
      children: hasDecoration && /*#__PURE__*/_jsx(Label, {
        color: "text-primary-default",
        background: "surface-neutral-default",
        children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['price'],
      children: /*#__PURE__*/_jsx(UIHeading2, {
        children: price
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description'],
      children: /*#__PURE__*/_jsx(UIText1, {
        children: flatInfo
      })
    }), /*#__PURE__*/_jsx("button", {
      className: style['link'],
      onClick: onClick,
      children: similarOffersCount
    })]
  });
};